class mmCard extends HTMLElement {
  constructor() {
    super();
    let shadow = this.attachShadow({mode: 'open'});
    
    const title = this.getAttribute('card-title');

    // HACK: the margin bottom is a temp solution for where a dropdown menu is on the bottom of the screen
    // The container does not take this into account and results in a scrolling container with a half cut off dropdown
    // menu, ideally the container should be sized taking that into account, another solution is to use a dropup instead
    shadow.innerHTML = `
      <style>
        .card {
          position: relative;
          display: flex;
          flex-direction: column;
          min-width: 0;
          word-wrap: break-word;
          background-color: #fff;
          background-clip: border-box;
          border: 1px solid rgba(0, 0, 0, 0.125);
          border-radius: 0;
          ${this.dataset.marginBottom ? 'margin-bottom: ' + this.dataset.marginBottom : ''}
        }
        .card-header {
          padding: 0.75rem 1.25rem;
          margin-bottom: 0;
          background-color: #406E8E;
          border-bottom: 1px solid rgba(0, 0, 0, 0.125);
          color: #ffffff;
        }
        .card-header:first-child {
          border-radius: 0;
        }
        .card-body {
          flex: 1 1 auto;
          min-height: 1px;
          padding: 1.25rem;
        }
      </style>

      <div class="card">
        <div class="card-header">
          ${title}    
        </div>
        <div class="card-body">
          <slot></slot>
        </div>
      </div>           
    `    
  } 

  connectedCallback() {

  }
}


window.customElements.define('mm-card', mmCard);